<template>
    <el-card class="box-card">
        <div class="component-content">
            <section class="content">
                <el-tabs v-model="activeName" @tab-click="handleClick">
                    <el-tab-pane label="中文审核" name="first">
                        <el-card>
                            <div slot="header" class="clearfix">
                                <span>审核操作<i class="el-icon-question" @click="drawer = true"></i></span>
                            </div>
                            <el-drawer
                                title="审核操作说明"
                                :visible.sync="drawer"
                                direction="rtl">
                                <div style="height: 300px;">
                                    <el-steps direction="vertical">
                                        <el-step title="步骤 1" status="process "
                                                 description="OC告知需要出新包/热更 并上传完对应json后，提示文案进行语言包上传">
                                        </el-step>
                                        <el-step title="步骤 2" status="process "
                                                 description="审核文案，通过界面进行选定/撤回"></el-step>
                                        <el-step title="步骤 3" status="process "
                                                 description="导出完成审核版本"></el-step>
                                        <el-step title="步骤 4" status="process "
                                                 description="更新语言包，更新完成之后游戏实装语言包"></el-step>
                                    </el-steps>
                                </div>
                            </el-drawer>
                            <el-form label-suffix=":">
                                <el-form-item label="">
                                    <el-row>
                                        <el-col :span="3">
                                            <el-tooltip class="item" effect="dark"
                                                        content="注：上传json会生成需审核记录"
                                                        placement="top-start">
                                                <el-button size="small"
                                                           @click="uploadJsonDialogVisible = true">上传JSON
                                                </el-button>
                                            </el-tooltip>
                                        </el-col>
                                        <el-col :span="3">
                                            <el-tooltip class="item" effect="dark"
                                                        content="注：上传上传excel会生成需审核记录"
                                                        placement="top-start">
                                                <el-button size="small" type="warning"
                                                           @click="uploadExcelDialogVisible = true">上传Excel
                                                </el-button>
                                            </el-tooltip>
                                        </el-col>
                                        <el-col :span="3">
                                            <el-button size="small" type="danger" @click="downloadVerifyExcel()">
                                                导出完成审核版本
                                            </el-button>
                                        </el-col>

                                        <el-col :span="3">
                                            <el-button size="small" type="success"
                                                       @click="uploadCnLangDialogVisible = true">更新语言包
                                            </el-button>
                                        </el-col>
                                    </el-row>
                                </el-form-item>
                            </el-form>
                            <el-dialog title="文件上传 - JSON" :visible.sync="uploadJsonDialogVisible" width="30%"
                                       :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false">
                                <el-upload class="uploLangConfTranVoad-demo"
                                           :on-success="handleResult"
                                           :action="uploadCnJsonUrl()"
                                           :on-change="handleChange"
                                           :file-list="uploadFileList">
                                    <el-button size="small" type="primary">上传文件</el-button>
                                </el-upload>
                                <span slot="footer" class="dialog-footer">
                                    <span>{{isUploadSuccess?'已上传':'未上传'}}</span>
                                    <el-button @click="closeImportCnJson()">关闭</el-button>
                                </span>
                            </el-dialog>
                            <el-dialog title="文件上传 - EXCEL" :visible.sync="uploadExcelDialogVisible" width="30%"
                                       :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false">
                                <el-upload class="uploLangConfTranVoad-demo"
                                           :on-success="handleUploadCnExcelResult"
                                           :action="uploadCnExcelUrl()"
                                           :on-change="handleUploadCnExcelChange"
                                           :file-list="uploadCnExcelFileList">
                                    <el-button size="small" type="primary">上传文件</el-button>
                                </el-upload>
                                <span slot="footer" class="dialog-footer">
                                    <span>{{isUploadSuccess?'已上传':'未上传'}}</span>
                                    <el-button @click="closeImportCnExcel()">关闭</el-button>
                                </span>
                            </el-dialog>
                            <el-dialog title="更新语言包 - EXCEL" :visible.sync="uploadCnLangDialogVisible" width="80%"
                                       :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false">
                                <el-upload class="uploLangConfTranVoad-demo"
                                           :on-success="handleUploadCnLangResult"
                                           :action="uploadCnLangUrl()"
                                           :on-change="handleUploadCnLangChange"
                                           :file-list="uploadCnLangFileList">
                                    <el-button size="small" type="primary">上传文件</el-button>
                                </el-upload>

                                <span>变动得数据量：({{uploadData.length}})</span>
                                <el-table :data="uploadData" border style="width: 100%">
                                    <el-table-column prop="id" label='编号'>
                                    </el-table-column>
                                    <el-table-column prop="before" label='修改前'>
                                    </el-table-column>
                                    <el-table-column prop="after" label='修改后'>
                                    </el-table-column>
                                    <el-table-column label='类型'>
                                        <template slot-scope="scope">
                                            {{ modifyMap[scope.row.type] }}
                                        </template>
                                    </el-table-column>
                                </el-table>

                                <span slot="footer" class="dialog-footer">
                                    <span>{{isUpdateSuccess?'已更新':'未更新'}}</span>
                                    <el-button type="warning" @click="confirmImportCnLang()">确定更新</el-button>
                                    <el-button @click="closeImportCnLang()">关闭</el-button>
                                </span>
                            </el-dialog>

                            <el-dialog title="上传语言包到OSS" :visible.sync="uploadToOSSDialogVisible" width="30%"
                                       :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false">
                                <div>
                                    <el-form label-width="60px">
                                        <el-form-item label="版本号:">
                                            <el-input v-model="uploadToOSSVersion"></el-input>
                                            <div class="version-tip">版本号说明(比如2023年1月9号第一次将中文更到44版本,填写为0.44.2023010901)</div>
                                        </el-form-item>
                                    </el-form>
                                </div>
                                <span slot="footer" class="dialog-footer">
                                    <el-button type="primary" @click="uploadToOSS">确认上传</el-button>
                                </span>
                            </el-dialog>
                        </el-card>
                        <el-card>
                            <div slot="header" class="clearfix">
                                <span>需审核内容(还需审核：{{ needCheckCount }},已审核：{{ alreadyCheckCount }})</span>
                            </div>
                            <el-form label-suffix=":">
                                <el-form-item>
                                    <el-button-group>
                                        <!--                                        <el-button size="small" @click="freshList()">刷新列表</el-button>-->
                                        <el-tooltip class="item" effect="dark"
                                                    content="注：只操作变更记录只有一条的内容(记录可能包含 修改项/迭代项)"
                                                    placement="top-start">
                                            <el-button size="small" type="success" @click="oneClickVerify()">一键处理新增
                                            </el-button>
                                        </el-tooltip>
                                        <el-button size="small" type="warning" @click="getVerifyCheckLog()">已审核列表
                                        </el-button>
                                    </el-button-group>
                                </el-form-item>

                                <el-form-item v-if="langChangeLog">
                                    <el-descriptions class="margin-top" title="审核数据" :column="1" size="" border>
                                        <el-descriptions-item>
                                            <template slot="label">
                                                编号
                                            </template>
                                            {{ langChangeLog.id }}
                                        </el-descriptions-item>
                                        <el-descriptions-item>
                                            <template slot="label">
                                                类型
                                            </template>
                                            <span v-if="langChangeLog.tab === 'create'">新增项</span>
                                            <span v-if="langChangeLog.tab === 'update'">迭代项</span>
                                            <span v-if="langChangeLog.tab === 'delete'">删除项</span>
                                        </el-descriptions-item>
                                        <el-descriptions-item>
                                            <template slot="label">
                                                数据库值
                                            </template>
                                            {{ langChangeLog.originValue }}
                                        </el-descriptions-item>
                                    </el-descriptions>
                                </el-form-item>
                                <el-form-item v-if="langChangeLog" style="margin-top: 50px;">
                                    <!--<el-table :data="langChangeLog.langConfVerifyItems" border style="width: 100%">-->
                                    <!--<el-table-column prop="adminName" label='修改人' width="200px">-->
                                    <!--</el-table-column>-->
                                    <!--<el-table-column prop="uploadTime" label='上传时间' width="300px">-->
                                    <!--</el-table-column>-->
                                    <!--<el-table-column prop="targetCnValue" label='excel修改值' width="700px">-->
                                    <!--</el-table-column>-->
                                    <!--<el-table-column label="操作">-->
                                    <!--<template slot-scope="scope">-->
                                    <!--<el-button type="warning" v-if="langChangeLog.status === 0"-->
                                    <!--@click="verifyFinish(langChangeLog.id,scope.row.id)">选定-->
                                    <!--</el-button>-->
                                    <!--</template>-->
                                    <!--</el-table-column>-->
                                    <!--</el-table>-->

                                    <div class="lang-change-box">
                                        <div v-for="item in langChangeLog.langConfVerifyItems" style="min-width: 500px;">
                                            <div class="selected-btn">
                                                <el-button style="width: 90%;" type="success" v-if="langChangeLog.status === 0"
                                                           @click="verifyFinish(langChangeLog.id,item.id)">选定
                                                </el-button>
                                            </div>
                                            <div class="top-part">
                                                <span>{{item.adminName == 'originValue' ? '数据库值:' : '修改人:'}}<el-tag type="success">{{item.adminName}}</el-tag></span>
                                                <span>上传时间: {{item.uploadTime}}</span>

                                            </div>
                                            <div class="time-value">
                                                {{item.content}}
                                            </div>
                                        </div>
                                    </div>
                                </el-form-item>
                            </el-form>

                            <el-dialog title="已审核列表" :visible.sync="alreadyCheckDialogVisible" width="80%"

                                       :close-on-click-modal="false" :close-on-press-escape="false">
                                <el-table :data="checkLogData" border style="width: 100%">
                                    <el-table-column prop="id" label='编号'>
                                    </el-table-column>
                                    <el-table-column prop="finishTime" label='审核时间' sortable>
                                    </el-table-column>
                                    <el-table-column prop="originValue" label='数据库值'>
                                    </el-table-column>
                                    <el-table-column prop="finalValue" label='最终值'>
                                    </el-table-column>
                                    <el-table-column prop="adminName" label='审核人'>
                                    </el-table-column>
                                    <el-table-column label='类型'>
                                        <template slot-scope="scope">
                                            <span v-if="scope.row.tab === 'create'">新增项</span>
                                            <span v-if="scope.row.tab === 'update'">迭代项</span>
                                            <span v-if="scope.row.tab === 'delete'">删除项</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column label='操作'>
                                        <template slot-scope="scope">
                                            <el-button size="small" type="danger" @click="verifyBack(scope.row.id)">撤回
                                            </el-button>
                                        </template>
                                    </el-table-column>
                                </el-table>

                                <span slot="footer" class="dialog-footer">
                                    <el-button @click="closeCheckDialog()">关闭</el-button>
                                </span>
                            </el-dialog>
                        </el-card>
                    </el-tab-pane>
                    <el-tab-pane label="多语言对比" name="second">
                        <el-card>
                            <el-form label-suffix=":" :inline="true">
                                <el-form-item label="本次对比语言">
                                    <el-select v-model="langRadio" placeholder="请选择">
                                        <el-option
                                            v-for="(lang,index) in exportLangType"
                                            :key="lang.value"
                                            :label="lang.label"
                                            :value="lang.value"
                                            v-if="lang.value !== 'cn'">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                                <!--<el-form-item label="语言包版本">-->
                                    <!--<el-select v-model="langVersionSelected" placeholder="请选择">-->
                                        <!--<el-option-->
                                            <!--v-for="(lang,index) in versionDataTable"-->
                                            <!--:key="lang.index"-->
                                            <!--:label="lang.version"-->
                                            <!--:value="lang.version">-->
                                        <!--</el-option>-->
                                    <!--</el-select>-->
                                <!--</el-form-item>-->
                                <el-form-item label="文件格式">
                                    <el-switch
                                        v-model="isExcel"
                                        active-color="#13ce66"
                                        inactive-color="#ff4949"
                                        :active-value="true"
                                        :inactive-value="false"
                                        active-text="excel"
                                        inactive-text="csv">
                                    </el-switch>
                                </el-form-item>
                                <el-form-item>
                                    <el-button size="small" type="danger" @click="exportCompareCurrentVersion()">
                                        导出对比中文差异
                                    </el-button>
                                </el-form-item>
                                <el-form-item>
                                    <el-button size="small" type="success"
                                               @click="uploadMultiExcelDialogVisible = true">
                                        多语言上传
                                    </el-button>
                                </el-form-item>
                                <el-form-item>
                                    <el-button size="small" type="" @click="exportJson">
                                        导出Json
                                    </el-button>
                                </el-form-item>
                            </el-form>
                        </el-card>
                        <el-dialog title="多语言文件上传 - EXCEL" :visible.sync="uploadMultiExcelDialogVisible" width="60%"
                                   :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false">
                            <el-upload class="uploLangConfTranVoad-demo"
                                       :on-success="handleUploadMultiExcelResult"
                                       :action="uploadMultiExcelUrl()"
                                       :on-change="handleUploadMultiExcelChange"
                                       :file-list="uploadMultiExcelFileList">
                                <el-button size="small" type="primary">上传文件</el-button>
                            </el-upload>

                            <div style="margin: 20px 0;">
                                <el-row>
                                    <blockquote v-for="(langItem,index) in exportLangType" :key="index"
                                                v-if="langItem.value ===langRadio">
                                        <span>本次对比语言：{{ langItem.label }}</span>
                                    </blockquote>
                                </el-row>
                                <el-row>
                                    <span>多语言上传 将对应目标语言上传并更新数据库</span>
                                </el-row>
                                <el-row>
                                    <span>(判断目标语言数据库的value值与excel的value值一致即上传成功，上传失败则弹出异常记录下载以及列表展示)</span>
                                </el-row>
                            </div>


                            <el-card>
                                <div slot="header" class="clearfix">
                                    <span>对比数据列表</span>
                                </div>
                                <el-table
                                    :data="dataHandled"
                                    style="width: 100%;"
                                    row-key="id"
                                    border
                                    default-expand-all>
                                    <el-table-column prop="id" label='编号'>
                                    </el-table-column>
                                    <el-table-column prop="before" label='修改前'>
                                    </el-table-column>
                                    <el-table-column prop="after" label='修改后'>
                                    </el-table-column>
                                    <el-table-column prop="type" label='操作类型'>
                                    </el-table-column>
                                </el-table>
                                <div class="pagination">
                                    <el-pagination @current-change="handleCurrentChange" :current-page="currentPage"
                                                   :page-size="pageSize"
                                                   layout="total, prev, pager, next, jumper" :total="totalRow">
                                    </el-pagination>
                                </div>
                            </el-card>

                            <span slot="footer" class="dialog-footer">
                                <el-button type="warning" @click="confirmImportLangExcel()">确定更新</el-button>
                                <el-button @click="closeImportMultiExcel()">关闭</el-button>
                            </span>
                        </el-dialog>
                    </el-tab-pane>
                </el-tabs>

            </section>
        </div>
    </el-card>
</template>

<script>
    import paginationController from '../../mixins/pagination'
    import actionConfirm from '../../mixins/action_confirm'
    import langConfApi from '../../service/lang_conf_api.js'
    import langVersionApi from '../../service/lang_version_api'
    import FileSaver from 'file-saver'
    import {
        mapState
    } from 'vuex';
    import {apis} from "../../lib/apis";
    import axios from "axios";
    import Utils from '../../lib/utils'

    export default {
        name: "logs",
        data() {
            return {
                title: this.$route.meta.title,
                Utils: Utils,
                activeName: 'first',
                drawer: false,
                langRadio: 'hant',
                exportDataList: [
                    {

                        id: 'sh',
                        val: '审核'
                    }, {

                        id: 'en',
                        val: '英文'
                    }, {

                        id: 'kr',
                        val: '韩文'
                    }, {

                        id: 'jp',
                        val: '日文'
                    }],
                statusMap: {
                    0: '未审核',
                    1: '已通过',
                    2: '已取消'
                },
                modifyMap: {
                    'create': '新增项',
                    'update': '迭代项',
                    'delete': '删除项'
                },
                langVerifyTmpLogs: [],
                exportLangType:[
                    {
                        id: 1,
                        label: '中文简体',
                        val: "zh-Hans",
                        value: 'cn'
                    },
                    {
                        id: 2,
                        label: '中文繁体',
                        val: "zh-Hant",
                        value: 'hant'
                    },
                    {
                        id: 3,
                        label: '日文',
                        val: "ja-jp",
                        value: 'jp'
                    },
                    {
                        id: 4,
                        label: '英文',
                        val: "en-US",
                        value: 'en'
                    },
                    {
                        id: 5,
                        label: '海外简体',
                        val: "oversea",
                        value: 'oversea'
                    },
                    {
                        id: 6,
                        label: '韩文',
                        val: "kr",
                        value: 'kr'
                    },
                ],
                langChangeLogs2: [
                    {
                        id: "19-2014",
                        cn: "对手列表",
                        excelCn: "对手列表",
                        content: "opn list",
                        excelContent: " opn",
                    },
                    {
                        id: "19-2015",
                        cn: "对手列表aa",
                        excelCn: "",
                        content: "",
                        excelContent: "",
                        backup: " excel缺失此串( 优于中文不一致)"
                    },
                    {
                        id: "19-2016",
                        cn: "对手列表aabb",
                        excelCn: "对手列表aabb",
                        content: "对手列表aabbsss",
                        excelContent: "sssss",
                        backup: "多语言包含特殊字符"
                    },
                    {
                        id: "19-2017",
                        cn: "对手列表aabc",
                        excelCn: "对手列表acs",
                        content: "ccc",
                        excelContent: "ddd",
                        backup: "中文串不一致"
                    },
                    {
                        id: "19-2018",
                        cn: "",
                        excelCn: "对手列表aabc",
                        content: "",
                        excelContent: "ssss",
                        backup: "数据库缺失此串"
                    }
                ],

                langChangeLog: {},
                needCheckCount: 0,
                alreadyCheckCount: 0,
                alreadyCheckDialogVisible: false,
                checkLogData: [],

                uploadJsonDialogVisible: false,
                uploadFileList: [],
                uploadFile: {},

                uploadExcelDialogVisible: false,
                uploadCnExcelFileList: [],
                uploadCnExcelFile: {},

                uploadCnLangDialogVisible: false,
                uploadData: [],
                uploadCnLangFileList: [],
                uploadCnLangFile: {},

                uploadMultiExcelDialogVisible: false,
                uploadMultiExcelFileList: [],
                uploadMultiExcelFile: {},

                isUploadSuccess: false,
                isUpdateSuccess: false,

                uploadToOSSVersion: '',
                uploadToOSSDialogVisible: false,

                // 语言包版本库数据
                versionDataTable: [],
                langVersionSelected: '',

                // 文件格式
                isExcel: true
            }
        },
        mixins: [paginationController, actionConfirm],
        computed: {
            ...mapState({
                token: state => state.user.userInfo.loginToken,
            }),
        },
        created() {
            this.getLangs();
            this.getVerifyLog();
            setTimeout(() => {
                this.isUploadSuccess = false;
            },1000)

        },
        methods: {
            handleClick(tab, event) {
                if (tab.name == 'second') {
                    this.getLangVersion();
                }
            },
            /**
             * JSON上传 - 1
             * @returns {string}
             */
            uploadCnJsonUrl() {
                return apis.verify_upload_json + '?token=' + this.token;
            },
            /**
             * JSON上传 - 2
             * @returns {string}
             */
            handleChange(file, fileList) {
                let self = this;
                self.uploadFile = file;
                self.uploadFileList = fileList;
            },
            /**
             * JSON上传 - 3
             * @returns {string}
             */
            handleResult(response, file, fileList) {
                this.getVerifyLog();
                console.log(response);
            },
            /**
             * JSON上传 - 4
             * @returns {string}
             */
            closeImportCnJson() {
                let self = this;
                self.uploadJsonDialogVisible = false;
                self.uploadFileList = [];
                self.uploadFile = {};
                self.isUploadSuccess = false;
            },

            /**
             * EXCEL上传 - 1
             * @returns {string}
             */
            uploadCnExcelUrl() {
                return apis.verify_upload_excel + '?token=' + this.token;
            },
            /**
             * EXCEL上传 - 2
             * @returns {string}
             */
            handleUploadCnExcelResult(response, file, fileList) {
                this.getVerifyLog();
                console.log(response);
            },
            /**
             * EXCEL上传 - 3
             * @returns {string}
             */
            handleUploadCnExcelChange(file, fileList) {
                let self = this;
                self.uploadCnExcelFile = file;
                self.uploadCnExcelFileList = fileList;
            },
            /**
             * EXCEL上传 - 4
             * @returns {string}
             */
            closeImportCnExcel() {
                let self = this;
                self.uploadExcelDialogVisible = false;
                self.uploadCnExcelFileList = [];
                self.uploadCnExcelFile = {};
                self.isUploadSuccess = false;
            },

            /**
             * EXCEL上传多语言 - 1
             * @returns {string}
             */
            uploadMultiExcelUrl() {
                if (this.langRadio == 'oversea') {
                    if (this.isExcel) {
                        return apis.upload_oversea_cn_excel + '?token=' + this.token + "&lang=" + this.langRadio + "&isExecute=false";
                    } else {
                        return apis.upload_oversea_csv + '?token=' + this.token + "&lang=" + this.langRadio + "&isExecute=false";
                    }
                } else {
                    if (this.isExcel) {
                        return apis.upload_lang_excel + '?token=' + this.token + "&lang=" + this.langRadio + "&isExecute=false";
                    } else {
                        return apis.upload_lang_csv + '?token=' + this.token + "&lang=" + this.langRadio + "&isExecute=false";
                    }
                }
            },

            // 确认更新对比过后Excel文档
            confirmImportLangExcel() {
                let self = this;
                let formData = new FormData();
                let item = self.uploadMultiExcelFile;

                if (item) formData.append('file', item.raw);

                if (self.isExcel) {
                    axios({
                        method: "post",
                        // url: apis.upload_lang_excel + '?token=' + self.token + "&lang=" + self.langRadio + "&isExecute=true",
                        url: (self.langRadio == 'oversea'?apis.upload_oversea_cn_excel:apis.upload_lang_excel) + '?token=' + self.token + "&lang=" + self.langRadio + "&isExecute=true",
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        },
                        data: formData
                    }).then(res => {
                        if (res.data.code == 0) {
                            self.$message({
                                type: 'success',
                                message: '更新成功!'
                            })
                        } else {
                            self.$message({
                                type: 'warning',
                                message: res.data.content
                            })
                        }
                    });
                } else {
                    axios({
                        method: "post",
                        url: (self.langRadio == 'oversea'?apis.upload_oversea_csv:apis.upload_lang_csv) + '?token=' + self.token + "&lang=" + self.langRadio + "&isExecute=true",
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        },
                        data: formData
                    }).then(res => {
                        if (res.data.code == 0) {
                            self.$message({
                                type: 'success',
                                message: '更新成功!'
                            })
                        } else {
                            self.$message({
                                type: 'warning',
                                message: res.data.content
                            })
                        }
                    });
                }

            },
            /**
             * EXCEL上传 - 2
             * @returns {string}
             */
            handleUploadMultiExcelResult(response, file, fileList) {
                console.log(response);
                // this.langVerifyTmpLogs = response.content;
                this.rawData = response.content;
                this.totalRow = response.content.length;
                this.$message({
                    type: 'success',
                    message: '上传成功!'
                })
            },
            /**
             * EXCEL上传多语言 - 3
             * @returns {string}
             */
            handleUploadMultiExcelChange(file, fileList) {
                let self = this;
                self.uploadMultiExcelFile = file;
                self.uploadMultiExcelFileList = fileList;
            },
            /**
             * EXCEL上传多语言 - 4
             * @returns {string}
             */
            closeImportMultiExcel() {
                let self = this;
                self.uploadMultiExcelDialogVisible = false;
                self.uploadMultiExcelFileList = [];
                self.uploadMultiExcelFile = {};
                self.rawData = [];
                self.totalRow = 0;
            },

            /**
             * EXCEL上传更新语言包 - 1
             * @returns {string}
             */
            uploadCnLangUrl() {
                return apis.lang_conf_cn_excel_upload + '?token=' + this.token;
            },
            /**
             * EXCEL上传更新语言包 - 2
             * @returns {string}
             */
            handleUploadCnLangResult(response, file, fileList) {
                this.uploadData = response.content;
                console.log(response);
            },
            /**
             * EXCEL上传更新语言包 - 3
             * @returns {string}
             */
            handleUploadCnLangChange(file, fileList) {
                let self = this;
                self.uploadCnLangFile = file;
                self.uploadCnLangFileList = fileList;
            },
            /**
             * EXCEL上传更新语言包 - 4
             * @returns {string}
             */
            closeImportCnLang() {
                let self = this;
                self.uploadCnLangDialogVisible = false;
                self.uploadData = [];
                self.uploadCnLangFileList = [];
                self.uploadCnLangFile = {};
                self.isUpdateSuccess = false;
            },
            confirmImportCnLang() {
                let self = this;
                let formData = new FormData();
                let item = self.uploadCnLangFile;

                if (item) formData.append('file', item.raw);

                axios({
                    method: "post",
                    url: apis.lang_conf_cn_excel_upload + '?token=' + self.token + "&isExecute=true",
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    },
                    data: formData
                }).then(res => {
                    let data = res['data'];
                    if (data.code === 0) {
                        this.isUpdateSuccess = true;
                        this.uploadToOSSDialogVisible = true;
                    } else {
                        this.isUpdateSuccess = false;
                    }
                });
            },
            getVerifyLog() {
                let self = this;
                langConfApi.getUncheckData({
                    token: self.token
                }).then(res => {
                    console.log(res)
                    self.langChangeLog = res.verifyData;
                    self.needCheckCount = res.needCheckCount;
                    self.alreadyCheckCount = res.alreadyCheckCount;

                    self.isUploadSuccess = true;
                });
            },
            getVerifyCheckLog() {
                let self = this;
                self.alreadyCheckDialogVisible = true;
                langConfApi.getVerifyList({
                    token: self.token
                }).then(res => {
                    console.log(res)
                    self.checkLogData = res;
                });
            },
            closeCheckDialog() {
                let self = this;
                self.alreadyCheckDialogVisible = false;
                self.checkLogData = [];
            },
            verifyFinish(i18nId, itemId) {
                console.log(i18nId, itemId);
                let self = this;
                let verifyItems = {};
                verifyItems[i18nId] = itemId;
                let verifyForm = {
                    verifyItems
                }
                langConfApi.verifyFinish({
                    verifyForm: verifyForm,
                    token: self.token,
                }).then(res => {
                    self.getVerifyLog();
                });
            },
            verifyBack(i18nId) {
                let self = this;
                langConfApi.verifyRevert({
                    i18nId: i18nId,
                    token: self.token,
                }).then(res => {
                    self.getVerifyCheckLog();
                });
            },
            downloadVerifyExcel() {
              langConfApi.downloadVerifyExcel();
            },

            oneClickVerify() {
                let self = this;
                console.log("一键审核");
                langConfApi.oneClickVerify({
                    token: self.token
                }).then(res => {
                    self.getVerifyLog();
                });
            },
            /* freshList() {
                 console.log("刷新列表");
                 this.getVerifyLog();
             }*/

            // 上传语言包到OSS
            uploadToOSS() {
                let self = this;
                // var lang = Utils.getCookie('lang');
              langConfApi.uploadToOSS({
                    token: self.token,
                    lang: 'cn',
                    version: self.uploadToOSSVersion
                }).then(res => {
                    self.$message({
                        type: 'success',
                        message: '上传成功!'
                    })
                    self.uploadToOSSDialogVisible = false;
                })
            },

            getLangVersion() {
                let self = this;
                var lang = Utils.getCookie('lang');
                langVersionApi.langVersionAll({
                    token: self.token,
                    lang: lang
                }).then(res => {
                    self.versionDataTable = res;
                    for (let index = 0; index < self.versionDataTable.length; index++) {
                        const element = self.versionDataTable[index];
                        element.lastTime = Utils.formatDate(element.lastTime);
                    }
                })
            },

            // 导出非中文版本的差异项全量Excel
            exportCompareCurrentVersion() {
                let self = this;
                if (self.langRadio == 'oversea') {
                    if (self.isExcel) {
                        langConfApi.compareOversea({
                            lang: self.langRadio
                        }).then(res => {

                        });
                    } else {
                        langConfApi.compareOverseaCsv({
                            lang: self.langRadio
                        }).then(res => {

                        });
                    }
                } else {
                    if (self.isExcel) {
                        langConfApi.exportCompareCurrentVersion({
                            lang: self.langRadio
                        }).then(res => {

                        });
                    } else {
                        langConfApi.exportCompareCurrentVersionCsv({
                            lang: self.langRadio
                        }).then(res => {

                        });
                    }
                }
            },

            // 导出Json
            exportJson() {
                let self = this;
                langConfApi.exportJson({
                    token: self.token,
                    lang: self.langRadio
                }).then(res => {
                    let jsonData = res;
                    const blob = new Blob([jsonData], {type: 'application/json'});
                    FileSaver.saveAs(blob, 'lang-' + self.langRadio + '.json');
                })
            },
        }
    }
</script>

<style scoped lang="less">
    .lang-change-box {
        overflow-x: scroll;
        display: flex;

        .selected-btn {
            text-align: center;
            border: 0.5px solid #EBEEF5;
            border-top: 2px solid #EBEEF5;
        }

        .top-part {
            border: 0.5px solid #EBEEF5;
            padding: 6px;
            display:flex;
            justify-content: space-between;
            align-items: center;
        }

        .time-value {
            border: 0.5px solid #EBEEF5;
            padding: 6px;
            width: 500px;
        }
    }

    .version-tip {
        color: red;
        font-size: 10px;
    }
</style>



// WEBPACK FOOTER //
// src/views/lang_dialog/lang_version_log.vue